// Constants for Pension Verification List API actions.
export const GET_PENSION_VERIFICATION_LIST = 'GET_PENSION_VERIFICATION_LIST';
export const GET_PENSION_VERIFICATION_LIST_SUCCESS = 'GET_PENSION_VERIFICATION_LIST_SUCCESS';
export const GET_PENSION_VERIFICATION_LIST_FAILURE = 'GET_PENSION_VERIFICATION_LIST_FAILURE';

// Constants for Pension Verification Document API actions.
export const GET_PENSION_VERIFICATION = 'GET_PENSION_VERIFICATION';
export const GET_PENSION_VERIFICATION_SUCCESS = 'GET_PENSION_VERIFICATION_SUCCESS';
export const GET_PENSION_VERIFICATION_FAILURE = 'GET_PENSION_VERIFICATION_FAILURE';

// Constants for Post Regenerate Pension Verification API actions.
export const POST_REGENERATE_PENSION_VERIFICATION = 'POST_REGENERATE_PENSION_VERIFICATION';
export const POST_REGENERATE_PENSION_VERIFICATION_SUCCESS = 'POST_REGENERATE_PENSION_VERIFICATION_SUCCESS';
export const POST_REGENERATE_PENSION_VERIFICATION_FAILURE = 'POST_REGENERATE_PENSION_VERIFICATION_FAILURE';